import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib';
import { RPESubActividad } from './rpe-sub-actividades.model';

export const entityRPESubActividadesAdapter: EntityAdapter<RPESubActividad> =
  createEntityAdapter<RPESubActividad>({
    selectId: (model) => model.actividad_id,
    sortComparer: (a: RPESubActividad, b: RPESubActividad): number =>
      b.actividad_id.toString().localeCompare(a.actividad_id.toString())
  });

export interface EntityRPESubActividadesState extends EntityState<RPESubActividad> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityRPESubActividadesState =
entityRPESubActividadesAdapter.getInitialState({
    isLoading: false,
    error: null
  });
